/**
 * A hashed Next.js chunk that disappeared after a deploy.
 *
 * Webpack reports `Loading chunk <id> failed`. Turbopack reports
 * `Failed to load chunk <url> from module <id>`. Browsers also surface a
 * dynamic import that never arrived. The tab reloads once into the new
 * build, so none of these are application faults.
 */
const CHUNK_LOAD_MESSAGE =
  /Loading chunk [\w-]+ failed|Loading CSS chunk|error loading dynamically imported module|Failed to fetch dynamically imported module|Failed to load chunk \S+ from module/i;

export const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';

/**
 * Patterns for Sentry `ignoreErrors`.
 *
 * A string is a substring of the exception message, including the
 * `Type: message` form Sentry builds when both are present. The regex covers
 * the same failures when the error name was dropped on the way.
 */
export const CHUNK_LOAD_IGNORE_ERRORS: Array<string | RegExp> = [
  CHUNK_LOAD_ERROR_NAME,
  CHUNK_LOAD_MESSAGE,
];

/** Whether this is a chunk that failed to load rather than a real fault. */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;

  const { name, message } = error as { name?: unknown; message?: unknown };

  if (name === CHUNK_LOAD_ERROR_NAME) return true;

  return typeof message === 'string' && CHUNK_LOAD_MESSAGE.test(message);
}
